import { apolloClient as client } from 'src/graphql/client/apollo-client';
import { IntegrationsDocument } from 'src/graphql/actions/integration/integrations.query';

export const refetchIntegrations = () => {
  client.cache.evict({ fieldName: 'integrations' });
  client.cache.gc();
  client.refetchQueries({
    include: [IntegrationsDocument],
  });
};
